import React from 'react';
import { Redirect } from 'react-router-dom';
import { Box } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import UnappliedFundsOrganizationsContainer from '@/modules/employer/components/UnappliedFunds/UnappliedFundsOrganizations';
import { useIsApplyUnmatchedPushAvailable } from '@/modules/featureFlags';
import theme from '@/styles/theme';

import Topbar from '../modules/core/components/Topbar';

const UnappliedFundsOrganizationsPage = () => {
  const isAvailable = useIsApplyUnmatchedPushAvailable();

  if (!isAvailable) {
    return <Redirect to={ROUTES.HOME} />;
  }

  return (
    <Box width="100%" height="fit-content">
      <Topbar />
      <Box align="center" margin={{ top: 'medium' }} pad={{ bottom: 'spacing72' }}>
        <Box width={theme.defaultContentWidth}>
          <UnappliedFundsOrganizationsContainer />
        </Box>
      </Box>
    </Box>
  );
};

export default UnappliedFundsOrganizationsPage;
